jQuery(document).ready(function ($) {
  var gallery = $('#gallery');
  var countSlides = gallery.children().length;

  gallery.slick({
    dots: countSlides > 1,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000
  });

  var sidebar = $('#sidebar-slider');
  var sidebarSlides = sidebar.children().length;

  sidebar.slick({
    dots: sidebarSlides > 1,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: false
  });
});
